import de from '@translations/de/pointsTable.json';
import en from '@translations/en/pointsTable.json';
import pl from '@translations/pl/pointsTable.json';
import sl from '@translations/sl/pointsTable.json';
import uk from '@translations/uk/pointsTable.json';
import bg from '@translations/bg/pointsTable.json';
import cz from '@translations/cz/pointsTable.json';
import fr from '@translations/fr/pointsTable.json';
import gr from '@translations/gr/pointsTable.json';
import it from '@translations/it/pointsTable.json';
import pr from '@translations/pr/pointsTable.json';
import ru from '@translations/ru/pointsTable.json';
import sk from '@translations/sk/pointsTable.json';
import sp from '@translations/sp/pointsTable.json';
import tr from '@translations/tr/pointsTable.json';
import hu from '@translations/hu/pointsTable.json';
import { ITranslations } from '@/types/common';
import { PointsTableTransFields } from './types';

export const pointsTableTranslations: ITranslations<PointsTableTransFields> = {
  name: 'pointsTable',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
